import { openConfirmModal } from '@consumer/services/modals'

const CARD_REGEX = /\bcard\b/i

export async function warnIfContainsCardWord (...values: (string | null | undefined)[]): Promise<void> {
  if (values.some(v => v && CARD_REGEX.test(v))) {
    const confirmed = await openConfirmModal({
      header: 'Compliance Warning',
      content: "Check with the compliance team before using the word 'card'",
      confirmLabel: 'Continue',
      cancelLabel: 'Cancel',
      onConfirm: () => true,
      onCancel: () => false,
    })
    if (confirmed !== true) {
      throw Object.assign(new Error(''), { displayed: true })
    }
  }
}
